// A partner's link (/p/<code>, src/worker/partners.ts) sets this cookie, so
// the homepage hands out the partner's setup prompt and MCP address.
const CODE = /^[a-z0-9][a-z0-9-]{1,31}$/;

export function partnerCode(): string | null {
  if (typeof document === "undefined") return null;
  const value = document.cookie.match(/(?:^|;\s*)ml_partner=([^;]+)/)?.[1];
  return value && CODE.test(value) ? value : null;
}
